export const influencerPaymentStatusLabel = (status) => {
  const map = {
    brand_pending: "결제대기",
    brand_cancelled: "결제취소",
    brand_failed: "결제실패",
    pending: "서핑크리 지급대기",
    paid: "서핑크리 지급완료",
    failed: "지급실패",
    cancelled: "지급취소",
  };
  return map[status] ?? status ?? "—";
};

export const influencerPaymentStatusClass = (status) => {
  if (status === "paid") return "bg-[#e8fff3] text-[#009d5c]";
  if (status === "pending") return "bg-[#fff7e6] text-[#d46b08]";
  if (status === "brand_pending") return "bg-[#fff7e6] text-[#d46b08]";
  if (status === "brand_cancelled" || status === "cancelled") {
    return "bg-[#fff1f0] text-[#d4380d]";
  }
  if (status === "brand_failed" || status === "failed") {
    return "bg-[#f1f5f9] text-[#64748b]";
  }
  return "bg-[#f1f5f9] text-[#64748b]";
};
